
import * as actionTypes from '../actions/actionTypes';

const INITIAL_STATE = {
    loading: false,
    storageStateObjects: {
        showMode: "none",
        showOverlay: false,
        storageStateList: {
            storages: [
                { name: "Source", availability: 90, state: "Alto Storage", status: "active" },
                { name: "Preview", availability: 10, state: "Online", status: "active" },
                { name: "CloudSource", availability: 80, status: "inactive", state: "Yes" },
                { name: "CloudPreview", availability: 95, status: "active", state: "No" },
                { name: "Thumbnail", availability: 20, status: "active", state: "Yes" }
            ]
        },
        storageStateEdit: {},
        storageStateDelete: {}
    },
}

const StorageStateReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case actionTypes.STORAGESTATE_UPDATE_STORAGESTATEOBJECTS:
            return {
                loading: false,
                storageStateObjects: { ...state.storageStateObjects, ...action.payload }
            }
        case actionTypes.STORAGESTATE_SET_LOADING:
            return { ...state, loading: action.payload }
        default:
            return state;
    }
}

export default StorageStateReducer;